export const algorithm = [
  {
    date: '2026年04月29日',
    data: [
      '含税收入 = 下单金额 * 97% ',
      '广告收入 =（含税收入-代下单平台费-粉丝福利-投流费）/（1+税点）',
      '广告执行价 = 广告收入 - 直播坑位费 /（1+税点）- 线下结佣 /（1+税点）',
      '返点金额 = <span style="color: red;">合作原价</span> * 返点比例',
      '实际所得 = 广告收入 - 返点金额<span style="color: red;"> / 1.06</span>',
      '红人分成 = 实际所得 * 分红比例',
      '公司所得 = 实际所得 - 红人分成',
    ]
  },
  {
    date: '2025年08月06日',
    data: [
      '含税收入 = 下单金额 * 97% ',
      '广告收入 =（含税收入-代下单平台费-粉丝福利-投流费）/（1+税点）',
      '广告执行价 = 广告收入 - 直播坑位费 /（1+税点）<span style="color: red;">- 线下结佣 /（1+税点）</span>',
      '返点金额 = 广告执行价 * 返点比例',
      '红人分成 =（广告收入-返点金额）* 分红比例',
      '公司所得 =（广告收入-返点金额）*（1 - 分红比例）',
    ]
  },
  {
    date: '2024年01月01日',
    data: [
      '含税收入 = 下单金额 * 97% 【2024年01月26日补充：当平台包含“<span style="color: red;">抖音星图</span>”】',
      '广告收入 =（含税收入-代下单平台费-粉丝福利-投流费）/（1+税点）<div style="color: #999;">【投流费：24/12/11新增字段】</div>',
      '广告执行价 = 广告收入-直播坑位费 /（1+税点）',
      '返点金额 = 广告执行价 * 返点比例',
      '红人分成 =（广告收入-返点金额）* 分红比例',
      '公司所得 =（广告收入-返点金额）*（1 - 分红比例）',
    ]
  },
  {
    date: '2023年02月01日',
    data: [
      '广告收入 =（含税收入-代下单平台费-粉丝福利）/（1+税点）',
      '微任务所得 = round（微任务价 * 70% , -2）',
      '微任务平台费 = 微任务价 - 微任务所得',
      '广告执行价 = 广告收入-（购物车费用 + 微任务价）/（1+税点）',
      '返点金额 = 广告执行价 * 返点比例',
      '红人分成 =（广告收入 - 微任务平台费 - 返点金额）* 分红比例',
      '公司所得 =（广告收入 - 微任务平台费 - 返点金额）*（1 - 分红比例）'

    ]
  },
  {
    date: '2022年05月18日',
    data: [
      '广告收入 =（含税收入-代下单平台费-粉丝福利）/（1+税点）',
      '微任务所得 = round（微任务价 * 70% , -2）',
      '微任务平台费 = 微任务价 - 微任务所得',
      '广告执行价 = 广告收入-（授权价 + 购物车费用 + 微任务价）/（1+税点）',
      '返点金额 = 广告执行价 * 返点比例',
      '红人分成 =（广告收入 - 微任务平台费 - 返点金额）* 分红比例',
      '公司所得 =（广告收入 - 微任务平台费 - 返点金额）*（1 - 分红比例）'
    ]
  },
  {
    date: '2021年01月12日',
    data: [
      '微任务所得 = 微任务价 - 微任务平台费',
      '含税收入（应收款）',
      '广告收入 = 含税收入 /（ 1 + 税点 ）- 粉丝福利',
      '执行价 = 广告收入 - 授权价 - 微任务价 - 购物车费用',
      '广告执行价 = 广告收入-（授权价 + 购物车费用 + 微任务价）/（1+税点）',
      '返点金额 = 广告执行价 * 返点比例 （注：返点比例不能大于100，返点金额不能大于执行价）',
      '微任务所得 = 微任务价 * 70%   (注：百位取整数 例：1614 => 1600)',
      '实际收入 = 广告执行价 - 返点金额 + 授权价 + 购物车收费 + 微任务所得',
      '红人分成 = 实际收入 × 分红比例',
      '公司所得 = 实际收入 ×（1 - 分红比例）'
    ]
  }
]
